import ChatMessages from './ChatMessages.js';
import ChatRecipients from './ChatRecipients.js';
import Contents from './Contents.js';
import ContentTypes from './ContentTypes.js';
import Engagements from './Engagements.js';
import Groups from './Groups.js';
import GroupsUsers from './GroupsUsers.js';
import Local from './Local.js';
import Permissions from './Permissions.js';
import Prefs from './Prefs.js';
import Ratings from './Ratings.js';
import Screens from './Screens.js';
import ScreenTypes from './ScreenTypes.js';
import Secure from './Secure.js';
import Users from './Users.js';

const obj = {
	ChatMessages,
	ChatRecipients,
	Contents,
	ContentTypes,
	Engagements,
	Groups,
	GroupsUsers,
	Local,
	Permissions,
	Prefs,
	Ratings,
	Screens,
	ScreenTypes,
	Secure,
	Users
};
export default obj;